import VExpansionPanelContent from 'vuetify/es5/components/VExpansionPanel/VExpansionPanelContent'

export default {
  name: 'form-content',
  extends: VExpansionPanelContent,
  watch: {
    isActive(value) {
      this.$emit('switch')
    },
  },
}
